import React from 'react';
import { FadeLayer } from './../../styled';
import { Image, VideoWrapper } from './styled';
import assset from './step-2-placeholder.png';

const wrapperStyle = {
  position: 'relative',
  display: 'flex',
  width: '100%',
  height: '100%'
};

class Step2 extends React.Component {
  constructor() {
    super();
    this.videoListener = this.videoListener.bind(this);
  }

  videoListener = () => {
    this.props.selectStep(3);
  };

  render() {
    if (this.props.currentStep !== 2) {
      return null;
    }
    return (
      <div style={wrapperStyle}>
        <FadeLayer />
        <VideoWrapper>
          {this.props.navigated ? (
            <img
              src="https://cdn.auth0.com/website/homepage/02_technologies.svg"
              alt="Technologies"
            />
          ) : (
            <video
              muted={'true'}
              onEnded={this.videoListener}
              autoPlay="true"
              src="https://videos.ctfassets.net/2ntc334xpx65/2dLaiXYipGw6cOksAS2qUU/7c6fb215e38ae66d38bc4fe591ff1820/02_Technology_1_.mp4"
            />
          )}
        </VideoWrapper>
      </div>
    );
  }
}

export default Step2;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step2/Step2.js